(() => {
 if (window.afsVideoInitialized) return;
 window.afsVideoInitialized = true;
 const setup = (root) => {
  root.querySelectorAll('[data-afs-video-toggle]').forEach((button) => {
   if (button.dataset.afsReady) return;
   button.dataset.afsReady = 'true';
   const video = button.closest('.afs-hero').querySelector('video');
   if (!video) return;
   const sync = () => { button.textContent = video.paused ? 'Play video' : 'Pause video'; button.setAttribute('aria-pressed', String(video.paused)); };
   if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) { video.autoplay = false; video.pause(); }
   video.addEventListener('pause', sync); video.addEventListener('play', sync); sync();
   button.addEventListener('click', () => { if (video.paused) video.play().catch(sync); else video.pause(); });
  });
 };
 setup(document);
 document.addEventListener('shopify:section:load', (event) => setup(event.target));
})();
